import { ChevronLeftIcon } from '@heroicons/react/24/outline';
import { Link } from 'react-router';

interface MobilePageHeaderProps {
  title: string;
  backTo: string;
}

/**
 * スマホで下層画面の上部に出す「戻る + タイトル」のヘッダー。md 以上ではパンくずを使う。
 */
export const MobilePageHeader = ({ title, backTo }: MobilePageHeaderProps) => (
  <div className="sticky top-0 z-20 grid grid-cols-[3rem_1fr_3rem] items-center border-b border-neutral-200 bg-white md:hidden">
    <Link to={backTo} aria-label="戻る" className="flex size-12 items-center justify-center text-zinc-800">
      <ChevronLeftIcon className="size-6" />
    </Link>
    <h1 className="truncate text-center font-bold">{title}</h1>
  </div>
);
